import React, { useContext, useState } from 'react';
import { updatePassword } from '../../../services/profileService';
import useSnackbar from '../../../hooks/useSnackbar';
import { Context as AuthContext } from '../../../contexts/authContext';
import { TwoFactorFormVerification } from '../2FA/TwoFactorFormVerification';
import { Severity } from '../../../types';
import { MDBox } from '../../MDBox';
import { MDTypography } from '../../MDTypography';
import { MDInput } from '../../MDInput';
import { MDButton } from '../../MDButton';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    height: 30,
    width: 300,
  },
}));

export function ChangePasswordForm() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCode, setShowCode] = useState(false);
  const { user } = useContext(AuthContext);
  const classes = useStyles();
  const toast = useSnackbar();

  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      toast("New Password doesn't match", Severity.error);
      return;
    }
    setShowCode(true);
  };

  const on2FASuccess = async () => {
    try {
      await updatePassword(currentPassword, newPassword, confirmPassword);
      toast('Password changed successfully', Severity.success);
      setShowCode(false);
      toast('Password changed successfully', Severity.success);
    } catch (error) {
      const e = error as any;
      toast(e.message || 'Failed to change password', Severity.error);
    }
  };

  if (!user?.twoFactorEnabled) {
    return (
      <MDBox
        width="900px"
        padding="20px"
        border="1px solid #ddd"
        borderRadius="8px"
        boxShadow="0 2px 4px rgba(0,0,0,0.1)"
      >
        <MDTypography variant="subtitle1" component="p">
          Change Password:
        </MDTypography>
        <MDTypography variant="subtitle1" component="p">
          Enable 2FA to change password
        </MDTypography>
      </MDBox>
    );
  }

  if (showCode) {
    return (
      <MDBox
        width="900px"
        padding="20px"
        border="1px solid #ddd"
        borderRadius="8px"
        boxShadow="0 2px 4px rgba(0,0,0,0.1)"
      >
        <MDTypography style={{ marginBottom: 30 }}>
          Please confirm 2FA code before changing password:
        </MDTypography>
        <TwoFactorFormVerification onVerifySuccess={on2FASuccess} />
      </MDBox>
    );
  }

  return (
    <MDBox
      width="900px"
      padding="20px"
      border="1px solid #ddd"
      borderRadius="8px"
      boxShadow="0 2px 4px rgba(0,0,0,0.1)"
    >
      <MDTypography variant="subtitle1">Change Password:</MDTypography>
      <div>
        <MDInput
          label="Current Password"
          variant="outlined"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          className={classes.textField}
          inputProps={{
            style: { height: '30px', padding: '6px', lineHeight: '30px' },
          }}
          InputLabelProps={{
            style: { top: '-7px' },
          }}
          InputProps={{
            style: { height: '40px' },
          }}
        />
      </div>
      <div>
        <MDInput
          label="New Password"
          type="password"
          variant="outlined"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className={classes.textField}
          inputProps={{
            style: { height: '30px', padding: '6px', lineHeight: '30px' },
          }}
          InputLabelProps={{
            style: { top: '-7px' },
          }}
          InputProps={{
            style: { height: '40px', display: 'flex' },
          }}
        />
      </div>
      <div style={{ marginBottom: 30 }}>
        <MDInput
          label="Confirm Password"
          type="password"
          variant="outlined"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className={classes.textField}
          inputProps={{
            style: { height: '30px', padding: '6px', lineHeight: '30px' },
          }}
          InputLabelProps={{
            style: { top: '-7px' },
          }}
          InputProps={{
            style: { height: '40px' },
          }}
        />
      </div>
      <div style={{ marginBottom: 30 }}>
        <MDButton
          variant="contained"
          color="primary"
          onClick={handleChangePassword}
          disabled={!newPassword || !currentPassword || !confirmPassword}
        >
          Change Password
        </MDButton>
      </div>
    </MDBox>
  );
}
